<ng-container *ngIf="enabled">
    <ng-container *ngTemplateOutlet="product.hasVariations ? withVariations : withoutVariations"></ng-container>
</ng-container>

<ng-template #withoutVariations>
    <div class="allocation-inventory--container">
        <ng-container *ngIf="{ allocationInventory: allocationInventoryQuantity$ | async, fetching: fetchingAllocationInventory$ | async } as vm">
            <ng-container *ngIf="!vm.fetching">
                <div *ngIf="vm.allocationInventory?.inStock; then inStock else outOfStock"></div>
                <ng-template #inStock>
                    <div>
                        My Inventory: {{vm.allocationInventory?.totalQty || 0}}
                    </div>
                </ng-template>

                <ng-template #outOfStock>
                    <div class="font-weight-bold text-danger">
                        Out of Stock
                    </div>
                </ng-template>
            </ng-container>
        </ng-container>
    </div>
</ng-template>


<ng-template  #withVariations>
    <div class="allocation-inventory--container">
        <ng-container *ngIf="{ allocationInventory: allocationInventoryQuantity$ | async, fetching: fetchingAllocationInventory$ | async } as vm">
            <ng-container *ngIf="!vm.fetching">
                <div *ngIf="vm.allocationInventory?.inStock; then inStock else outOfStock"></div>
                <ng-template #inStock>
                    <div>
                        My Inventory: {{vm.allocationInventory?.totalQty || 0}}
                    </div>
                </ng-template>

                <ng-template #outOfStock>
                    <div class="font-weight-bold text-danger">
                        Out of Stock
                    </div>
                </ng-template>
            </ng-container>
        </ng-container>
    </div>
</ng-template>
